<template>
  <el-card class="user-content-panel">
    <div slot="header">
      <span class="panel-header">公告通知</span>
    </div>

    <el-table :data="noticeList" :show-header="false" class="notice-table">
      <el-table-column label="标题">
        <template slot-scope="scope">
          <span class="notice-subject" @click="viewNotice(scope.row)">{{ scope.row.noticeTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column label="时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.startDate | parseTime('{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
    </el-table>

    <NoticeContent ref="notice-content" />
  </el-card>
</template>

<script>
import NoticeContent from './components/notice-content'
import userApi from '@/api/user'
export default {
  name: 'notice-list',
  components: {
    NoticeContent
  },
  created () {
    this.queryNoticeList()
  },
  data () {
    return {
      noticeList: []
    }
  },
  methods: {
    viewNotice (notice) {
      this.$refs['notice-content'].show(notice)
    },
    // 获取公告列表
    queryNoticeList () {
      const params = {
        noticeType: '01'
      }
      userApi.queryNoticeList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.noticeList = res.data.resultData.noticeList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-table {
  width: 96%;
  margin: 0 auto;

  .notice-subject {
    cursor: pointer;

    &:hover {
      color: $base-red;
    }
  }
}
</style>
